"use client";

import { useEffect } from "react";

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      const registerSW = async () => {
        try {
          // Unregister any existing service workers first
          const registrations =
            await navigator.serviceWorker.getRegistrations();
          for (let registration of registrations) {
            if (registration.scope.includes("firebase-messaging-sw")) {
              await registration.unregister();
            }
          }

          // Register the service worker
          const registration = await navigator.serviceWorker.register(
            "/firebase-messaging-sw.js",
            {
              scope: "/",
              updateViaCache: "none",
            },
          );

          // Wait for the service worker to be ready
          await navigator.serviceWorker.ready;
        } catch (error) {
        }
      };

      registerSW();
    }
  }, []);

  return null;
}
